import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from '@angular/router';
import { ClaimStatsService } from './claimstatsservice';
import { catchError, map } from 'rxjs/operators';
import { of } from "rxjs";
import { SessionService } from "./sessionservice";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";

@Injectable()
export class DashboardResolver {
  constructor(private claimStatsService: ClaimStatsService,
                @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
                  private sessionService:SessionService) {    

  }
  resolve(route: ActivatedRouteSnapshot) {
     if(this.sessionService.userId === '' || this.sessionService.userId === undefined)
      this.sessionService.userId = this.oktaAuth.authStateManager.getAuthState()?.idToken?.claims.email ?? '';
    if(this.sessionService.userOrg === '' || this.sessionService.userOrg === undefined)
      this.sessionService.userOrg = String(this.oktaAuth.authStateManager.getAuthState()?.idToken?.claims.orgval ?? ''); 
    if(this.sessionService.idToken === '' || this.sessionService.idToken === undefined)
      this.sessionService.idToken = this.oktaAuth.authStateManager.getAuthState()?.idToken?.idToken;   
    return this.claimStatsService.getStats().pipe(map(result => result),
    catchError((error) => {
      const message = `Retrieval error: ${error?.error?.errorMessage}`;
      //console.error(error);
      return of({ error: message });
    }));
  }
}
